// src/components/personal/sections/OrdersSection/error/error-constants.ts
export const ERROR_CODES = {
    NETWORK_ERROR: 'NETWORK_ERROR',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    SERVER_ERROR: 'SERVER_ERROR',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
    ORDER_UPDATE_ERROR: 'ORDER_UPDATE_ERROR',
    PAYMENT_ERROR: 'PAYMENT_ERROR',
    EXPORT_ERROR: 'EXPORT_ERROR'
  } as const;
  
  // Ключи переводов для сообщений об ошибках
  export const ERROR_TRANSLATION_KEYS = {
    [ERROR_CODES.NETWORK_ERROR]: 'errors.network',
    [ERROR_CODES.VALIDATION_ERROR]: 'errors.validation',
    [ERROR_CODES.NOT_FOUND]: 'errors.not_found',
    [ERROR_CODES.UNAUTHORIZED]: 'errors.unauthorized',
    [ERROR_CODES.FORBIDDEN]: 'errors.forbidden',
    [ERROR_CODES.SERVER_ERROR]: 'errors.server',
    [ERROR_CODES.UNKNOWN_ERROR]: 'errors.unknown',
    [ERROR_CODES.ORDER_UPDATE_ERROR]: 'errors.status_update_error',
    [ERROR_CODES.PAYMENT_ERROR]: 'errors.payment_add_error',
    [ERROR_CODES.EXPORT_ERROR]: 'errors.export_error'
  } as const;
  
  // Сохраняем для обратной совместимости
  export const ERROR_MESSAGES = {
    [ERROR_CODES.NETWORK_ERROR]: 'Ошибка подключения к сети',
    [ERROR_CODES.VALIDATION_ERROR]: 'Ошибка валидации данных',
    [ERROR_CODES.NOT_FOUND]: 'Запрашиваемый ресурс не найден',
    [ERROR_CODES.UNAUTHORIZED]: 'Требуется авторизация',
    [ERROR_CODES.FORBIDDEN]: 'Доступ запрещен',
    [ERROR_CODES.SERVER_ERROR]: 'Ошибка сервера',
    [ERROR_CODES.UNKNOWN_ERROR]: 'Произошла неизвестная ошибка',
    [ERROR_CODES.ORDER_UPDATE_ERROR]: 'Ошибка обновления статуса заказа',
    [ERROR_CODES.PAYMENT_ERROR]: 'Ошибка при добавлении платежа',
    [ERROR_CODES.EXPORT_ERROR]: 'Ошибка при экспорте данных'
  } as const;